export default __webpack_public_path__ + "static/media/Bin.c9e55d2d.svg";